
import { createApi } from "@reduxjs/toolkit/query/react";
import { baseAuthQuery } from "../base/baseApi";
import { ApiResponse } from "../base/apiResponse";
import { PlanTypeResponse } from "../../models/dtos";

export const planTypesApi = createApi({
  reducerPath: 'planTypesApi',
  baseQuery: baseAuthQuery('PlanTypes'),
  tagTypes: ['PlanType'],
  endpoints: (builder) => ({
    getPlanTypes: builder.query<ApiResponse<PlanTypeResponse[]>, void>({
      query: () => "",
      providesTags: ['PlanType'],
    }),
    getPlanTypeById: builder.query<ApiResponse<PlanTypeResponse>, number>({
      query: (id) => ({ url: `/${id}` }),
      providesTags: ['PlanType'],
    }),
    updatePlanType: builder.mutation<ApiResponse<PlanTypeResponse>, Partial<PlanTypeResponse>>({
      query: (body) => ({ url: "CreateOrUpdate", method: "POST", body }),
      invalidatesTags: ['PlanType'],
    }),
    deletePlanType: builder.mutation<ApiResponse<boolean>, number>({
      query: (id) => ({ url: `Delete/${id}`, method: "GET" }),
      invalidatesTags: ['PlanType'],
    }),
  }),
});
